<template>
    <div class="manual-build-receipt">
        <div class="steps-box">
            <Steps :current="$store.state.steps">
                <Step :title="name"></Step>
                <Step title="填写价格及数量"></Step>
                <Step title="订单提交完成" icon="ios-thumbs-up-outline"></Step>
            </Steps>
        </div>
        <router-view/>
    </div>
</template>

<script>
export default {
    data() {
        return {
            // 步骤条
            current: 0,
            name: ''
        };
    },
    mounted() {
        if (this.$route.query.projectStatus === '1' && this.$route.query.type === 'home') {
            this.name = '选择计划';
        } else {
            this.name = '选择物资';
        }
    }
};
</script>

<style lang="stylus">

@import '../assets/stylus/views/manual-build.styl'

</style>



// WEBPACK FOOTER //
// src/views/ManualBuildReceipt.vue